import React from 'react';

export interface ILabelProps {
    title?: string;
    textSize?: "xs" | "sm" | "md" | "lg";
    labelClassName?: string;
}

const Label: React.FC<ILabelProps> = ({ title, textSize = "sm", labelClassName }) => {
    return (
        <label className={`text-${textSize} font-semibold text-msi-midblue-color-500 ${labelClassName}`}>{title}</label>
    );
    
};

export default Label;